import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng/errorBoundary';
import NewsTitle from '../../../components/newsTitle';
import NewsList from '../../../components/newsList';
import NewsBox from '../../../components/newsBox';

class CenterNewsBox extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { entTitle, entListTitle, entList0, shopInEnt, entList1, entNewsBox },
        } = this.props;

        return (
            <div className={styles.center_box}>
                <Chip id="230186" type="struct" title="娱乐标题" groupName="娱乐" content={entTitle}>
                    <NewsTitle size="middle" />
                </Chip>
                <Chip
                    id="195910"
                    type="recommend"
                    title="娱乐头条"
                    groupName="娱乐"
                    content={entListTitle}
                    translate="handleNewsData">
                    <NewsList hasTitle size="long" />
                </Chip>
                <Chip
                    id="195864"
                    type="recommend"
                    title="娱乐列表1"
                    groupName="娱乐"
                    content={entList0}
                    translate="handleNewsData">
                    <NewsList size="long" />
                </Chip>
                <Chip
                    id="255867"
                    type="recommend"
                    title="娱乐区电商"
                    groupName="娱乐"
                    content={shopInEnt}
                    translate="handleNewsData">
                    <NewsList size="long" />
                </Chip>
                <Chip
                    id="225748"
                    type="recommend"
                    title="娱乐列表2"
                    groupName="娱乐"
                    content={entList1}
                    translate="handleNewsData">
                    <NewsList size="long" />
                </Chip>
                <Chip
                    id="225749"
                    type="recommend"
                    title="娱乐新闻盒"
                    groupName="娱乐"
                    content={entNewsBox}
                    translate="handleNewsData">
                    <NewsBox />
                </Chip>
            </div>
        );
    }
}

export default errorBoundary(CenterNewsBox);
